import { Button } from '@/components/ui/button';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertCircle, RefreshCw } from 'lucide-react';

interface ErrorAlertProps {
  message: string;
  onRetry: () => void;
}

export const ErrorAlert = ({ message, onRetry }: ErrorAlertProps) => (
  <Alert variant="destructive">
    <AlertCircle className="h-4 w-4" />
    <AlertTitle>Analysis Failed</AlertTitle>
    <AlertDescription className="flex items-center justify-between">
      <span>{message}</span>
      <Button variant="outline" size="sm" onClick={onRetry} className="gap-1 ml-4">
        <RefreshCw className="w-3 h-3" />
        Retry
      </Button>
    </AlertDescription>
  </Alert>
);
